import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { Style, SurveyVersion } from '../../models';
import { StyleDataService } from '../../services';
import { FilterStore, UserStore } from '../../stores';
import { BaseRouteProps } from '../../interfaces';
import { LoadingIndicator } from '../loadingIndicator/LoadingIndicator';
import { PdfStyle } from './pdf_style';
import '../../components/reports/blocks/PVAStyle.css';
import '../reports/blocks/PVAStyleBreakdown.css';


interface PdfStylePreviewProps extends BaseRouteProps<{ id: string }> {
    FilterStore?: FilterStore;
    UserStore?: UserStore;
}

interface PdfStylePreviewState {
    loading: boolean;
    style: Style | null;
    allStyles: Style[];
}

@inject('FilterStore', 'UserStore')
@observer
export class PdfStylePreview extends React.Component<PdfStylePreviewProps, PdfStylePreviewState> {
    private styleDataService = new StyleDataService(this.props.notificationService);

    constructor(props: PdfStylePreviewProps) {
        super(props);
        this.state = {
            loading: true,
            style: null,
            allStyles: []
        };
    }

    public componentDidMount() {
        const styleId = parseInt(this.props.match.params.id, 10);
        
        this.styleDataService.get(styleId).then((style: Style) => {
            if (style && style.surveyVersionID) {
                this.styleDataService.getAllBySurveyVersionId(style.surveyVersionID).then((allStyles: Style[]) => {
                    this.setState({
                        style,
                        allStyles,
                        loading: false
                    });
                });
            } else {
                this.setState({
                    style,
                    loading: false
                });
            }
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    private GetTextType(style: Style, languageId: number, textType: string) {
        if (!style.styleTexts || style.styleTexts.length === 0) {
            return '';
        }

        const text = style.styleTexts.filter((x => x.languageId === languageId && x.styleTextType === textType));
        if (text && text.length > 0) {
            return text[0].value;
        }
        return '';
    }

    public render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }

        const { style, allStyles } = this.state;
        if (!style) {
            return <div>Style not found</div>;
        }

        const user = this.props.UserStore && this.props.UserStore.userInfo;
        const userName = user ? `${user.firstName} ${user.lastName}` : 'Preview User';
        const organizationName = (user && user.organization && user.organization.name) || 'Preview Organization';
        const date = new Date().toLocaleDateString();

        const selectedUserData = {
            name: style.name,
            style: {
                ...style,
                brief: this.GetTextType(style, 1, 'brief'),
                content: this.GetTextType(style, 1, 'content'),
                core: style.core
            }
        };

        const surveyVersion = this.props.FilterStore && this.props.FilterStore.surveyVersion;

        return (
            <div className="pdf-preview-container" style={{ padding: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
                <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#fff', border: '1px solid #ccc' }}>
                    <strong>PDF Preview Mode</strong> (Superadmin only)
                </div>
                <div className="pdf-content-wrapper" style={{ backgroundColor: '#fff', boxShadow: '0 0 10px rgba(0,0,0,0.1)', width: '800px', margin: '0 auto' }}>
                    <PdfStyle
                        userName={userName}
                        date={date}
                        organization={organizationName}
                        selectedUserData={selectedUserData}
                        surveyVersion={surveyVersion || null}
                        allStyles={allStyles}
                        {...this.props}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pvastyles/PdfStylePreview.tsx